






import { Component, Vue } from "vue-property-decorator";
import LabSupervisiList from "@/components/lab/supervisi/LabSupervisiList.vue";

@Component({
  components: { LabSupervisiList }
})
export default class LabSupervisiPage extends Vue {}
